import { getVersionForClone } from '@qr-front/ui/utils'

export const HERO_COUNTER_MULTIPLIER = getVersionForClone({
	base: 1,
	clone1: 0.5,
})

// Must stay free of module-scope references: HeroCounterLiveScript serializes
// this function with toString() and runs it in global scope, where bundler-
// mangled module bindings do not exist.
export const getHeroCounterValue = (multiplier: number): number => {
	const now = new Date()
	const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
	const dateSeed = today.getTime()
	const hourlyBaseRate = 1500 + (dateSeed % 500)
	const secondsSinceMidnight =
		now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds()
	const completedHoursCount = Math.floor(secondsSinceMidnight / 3600)
	const completedHoursTotal = completedHoursCount * hourlyBaseRate
	const secondsIntoCurrentHour = secondsSinceMidnight % 3600
	const currentHourProgress = secondsIntoCurrentHour / 3600
	const currentHourContribution = Math.floor(hourlyBaseRate * currentHourProgress)
	const minuteSeed = Math.floor(secondsSinceMidnight / 60)
	const pseudoRandom = ((dateSeed + minuteSeed) % 100) / 100
	const randomVariation = Math.floor(pseudoRandom * 20) - 10
	const counterValue = Math.floor(
		(completedHoursTotal + currentHourContribution + randomVariation) *
			multiplier,
	)
	return Math.max(0, counterValue)
}
